import React from "react";
import { injectIntl } from "react-intl";
import { withTheme } from "styled-components";
import {
  ContentShare,
  useContentShareState,
  useContentShareControls,
  useLocalVideo,
  useRemoteVideoTileState,
  useRosterState,
} from "amazon-chime-sdk-component-library-react";
import MeBlock from "./meBlock";
import FeaturedTile from "./featuredTile";

const SingleTile = withTheme(
  injectIntl(({ intl, theme }) => {
    const { tileId: contentTileId } = useContentShareState();
    const { isLocalUserSharing } = useContentShareControls();
    const { tiles } = useRemoteVideoTileState();
    const { isVideoEnabled } = useLocalVideo();
    const { roster } = useRosterState();

    const blocks = {
      default: <MeBlock />,
      featured: <FeaturedTile />,
      screen: <ContentShare css="grid-area: ft;" />,
    };

    const featureOrLocal = block => {
      if (isVideoEnabled) {
        block = "default";
      }
      if (tiles?.length > 1 || roster?.length > 1) {
        block = "featured";
      }
      return block;
    };

    const calculateTile = () => {
      let block = "default";
      block = featureOrLocal(block);
      if (contentTileId !== null) {
        block = "screen";
        if (isLocalUserSharing) {
          block = featureOrLocal(block);
        }
      }
      if (tiles?.length > 0) {
        block = "featured";
      }
      return blocks[block];
    };

    return calculateTile();
  })
);

export default SingleTile;
